export function hideEditorTabs(selectedKind: string | undefined): boolean {
  return selectedKind === "case";
}
